import * as React from "react";
import { useCookieConsent } from "common/cookie_consent/store";
var MeasurementComponent = function () {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        window.dataLayer.push(args);
    }
    gtag('js', new Date());
    gtag('config', 'G-B7SM1FHX23');
    return React.createElement(React.Fragment, null);
};
var MarketingComponent = function () {
    return React.createElement(React.Fragment, null);
};
export var AnalyticalComponent = function () {
    var state = useCookieConsent()[0];
    return React.createElement(React.Fragment, null, state.consentGiven && React.createElement(React.Fragment, null,
        state.cookieMeasurement && React.createElement(MeasurementComponent, null),
        state.cookieMarketing && React.createElement(MarketingComponent, null)));
};
